export default __webpack_public_path__ + "static/media/Play_Button.ebbcb7bc.svg";